var _rect, _rect2, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMyDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -129,
    y: -2463,
    width: 3820,
    height: 6924,
    stroke: "black",
    strokeWidth: 10,
    strokeDasharray: "50 50"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_8549)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -32,
    y: -14,
    width: 957,
    height: 650,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9_8549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.82449 13.2709H2.46783C1.29533 13.2709 0.729492 12.7284 0.729492 11.6084V2.39169C0.729492 1.27169 1.30116 0.729187 2.46783 0.729187H4.82449C5.99699 0.729187 6.56283 1.27169 6.56283 2.39169V11.6084C6.56283 12.7284 5.99116 13.2709 4.82449 13.2709ZM2.46783 1.60419C1.72699 1.60419 1.60449 1.80252 1.60449 2.39169V11.6084C1.60449 12.1975 1.72699 12.3959 2.46783 12.3959H4.82449C5.56533 12.3959 5.68783 12.1975 5.68783 11.6084V2.39169C5.68783 1.80252 5.56533 1.60419 4.82449 1.60419H2.46783Z",
    fill: "#5932EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5325 8.02085H9.17583C8.00333 8.02085 7.4375 7.47835 7.4375 6.35835V2.39169C7.4375 1.27169 8.00917 0.729187 9.17583 0.729187H11.5325C12.705 0.729187 13.2708 1.27169 13.2708 2.39169V6.35835C13.2708 7.47835 12.6992 8.02085 11.5325 8.02085ZM9.17583 1.60419C8.435 1.60419 8.3125 1.80252 8.3125 2.39169V6.35835C8.3125 6.94752 8.435 7.14585 9.17583 7.14585H11.5325C12.2733 7.14585 12.3958 6.94752 12.3958 6.35835V2.39169C12.3958 1.80252 12.2733 1.60419 11.5325 1.60419H9.17583Z",
    fill: "#5932EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5325 13.2706H9.17583C8.00333 13.2706 7.4375 12.7281 7.4375 11.6081V10.5581C7.4375 9.43813 8.00917 8.89563 9.17583 8.89563H11.5325C12.705 8.89563 13.2708 9.43813 13.2708 10.5581V11.6081C13.2708 12.7281 12.6992 13.2706 11.5325 13.2706ZM9.17583 9.77063C8.435 9.77063 8.3125 9.96896 8.3125 10.5581V11.6081C8.3125 12.1973 8.435 12.3956 9.17583 12.3956H11.5325C12.2733 12.3956 12.3958 12.1973 12.3958 11.6081V10.5581C12.3958 9.96896 12.2733 9.77063 11.5325 9.77063H9.17583Z",
    fill: "#5932EA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_8549"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -32,
    y: -14,
    width: 957,
    height: 650,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9_8549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyDay);
export default __webpack_public_path__ + "static/media/myDay.354159edb88076deb96ab42f5a094b45.svg";
export { ForwardRef as ReactComponent };